<script>
  import {
    SvelteTable,
    CardLayout,
    Loader,
  } from "../../../Components/Common/index.svelte";
  import { apiMethods } from "../../../Services/index.svelte";

  import {
    getFormatDateAndTime,
    getText,
    renderTFIcons,
    showError,
  } from "../../../Utils/utilFunctions.svelte";

  export let pushNotifications = [];
  export let commsDoctorId;
  export let scrollableContainerRef;

  $: if (loadMoreIconRef && scrollableContainerRef) {
    intersectionObserver = new IntersectionObserver(handleIntersect, {
      threshold: 0,
      root: scrollableContainerRef,
    });
    intersectionObserver.observe(loadMoreIconRef);
  }

  let intersectionObserver,
    loadMoreIconRef,
    loadMoreIndex = 0,
    isLoadingMore = false,
    showLoadMoreIcon = true;

  const columns = [
    {
      key: "dateToSend",
      title: "Date to Send",
      headerClass: "text-left pl-3 cursor-default w-[10%]",
      class: "text-left pl-3 cursor-pointer w-[10%]",
      value: (v) => _getFormatDate(v.dateToSend),
    },
    {
      key: "title",
      title: "Title",
      headerClass: "text-left pl-3 cursor-default w-[20%]",
      class: "text-left pl-3 cursor-pointer w-[20%]",
      renderValue: (v) => getText(v.title),
    },
    {
      key: "content",
      title: "Content",
      headerClass: "text-left pl-3 cursor-default w-[30%]",
      class: "text-left pl-3 cursor-pointer w-[30%]",
      renderValue: (v) => getText(v.content),
    },
    {
      key: "sent",
      title: "Sent",
      headerClass: "text-left pl-3 cursor-default w-[2%]",
      class: "text-left px-3 cursor-pointer",
      renderValue: (v) => renderTFIcons(v.sent),
    },
  ];

  const loadMorePushNotifications = async () => {
    if (isLoadingMore) return;

    isLoadingMore = true;
    showLoadMoreIcon = false;

    await apiMethods.getMethod
      .getAccountNotifications(commsDoctorId, {
        "filter[notificationType]": "pushNotifications",
        start: 51 + loadMoreIndex * 25,
        limit: 25,
      })
      .then((res) => {
        if (!res || res.error)
          showError(
            res.error ??
              "Failed to load more push notifications, please refresh the page and try again and contact support if the issue persists.",
          );
        else if (res.pushNotifications && !!res.pushNotifications.length) {
          showLoadMoreIcon = res.pushNotifications.length == 25;
          loadMoreIndex++;
          pushNotifications = [...pushNotifications, ...res.pushNotifications];
        } else showLoadMoreIcon = false;
      });

    isLoadingMore = false;
  };

  const _getFormatDate = (date) => {
    if (date == "0001-01-01T00:00:00") return "-";

    return getFormatDateAndTime(date);
  };
</script>

<CardLayout title="Push Notifications">
  <div class="flex flex-col flex-1 w-full lg:flex-row">
    {#if pushNotifications.length}
      <div class="flex flex-col gap-y-2 w-full overflow-x-auto">
        <SvelteTable {columns} rows={pushNotifications} />

        <!-- <div
          class={`flex flex-1 items-center justify-center py-1 ${showLoadMoreIcon && !isLoadingMore ? "" : "hidden"}`}
          bind:this={loadMoreIconRef}
        >
          <Loader />
        </div> -->
        {#if showLoadMoreIcon && pushNotifications.length >= 50}
          <div
            class="flex flex-1 items-center justify-center py-2 gap-x-2 underline {isLoadingMore
              ? `cursor-not-allowed`
              : 'cursor-pointer hover:font-bold'}"
            on:click|preventDefault={loadMorePushNotifications}
          >
            {#if isLoadingMore}
              <Loader />
            {/if}
            <p>
              {isLoadingMore ? "Loading..." : "Load More"}
            </p>
          </div>
        {/if}
      </div>
    {:else}
      <div
        class="flex flex-col flex-1 px-2 py-4 w-full bg-white rounded-b-2xl lg:flex-row"
      >
        <p>No push notifications</p>
      </div>
    {/if}
  </div>
</CardLayout>
